import React from 'react';

function Title(props) {
    return (
        <div>
            <div>Please consider downloading Runelite and installing the ToG Crowdsourcing plugin to help collect data.</div>
            <br/>
            <div>Download Runelite from runelite.net</div>
        </div>

    )
}

export default Title;
